import * as React from "react";
import { useHistory, Link } from "react-router-dom"
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DropdownFilterElement, getCity, renderHeader, getRegion } from "../../components/TableUtils";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { getUrlParameter } from "../../utils/history"
import { deleteTenant } from "../../api/tenants";

export default function TenantsList() {
  let dtable;
  const { push } = useHistory();

  const [openModal, setOpenModal] = React.useState(false);
  const toggle = () => setOpenModal(!openModal);

  const onDelete = async id => {
    const value = await deleteTenant(id);
    toggle();
    forceRefresh();
    return value;
  };

  const modalSection = () => (
    <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
      <ModalHeader toggle={toggle}>
        Eliminazione Dealer
      </ModalHeader>
      <ModalBody>
        <p>Confermi di voler eliminare il Dealer {openModal.name}?</p>
      </ModalBody>
      <ModalFooter>
        <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
        <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
      </ModalFooter>
    </Modal>
  );

  const {
    geo,
    associatedTenants,
    activeTenant,
    user,
    changeActiveTenant
  } = useAuth0();

  const onSetActiveTenant = tenant => {
    changeActiveTenant(tenant);
    const from = getUrlParameter('from');
    push(from);
  };

  const isAdmin = user.isInRole([roles.ADMIN])

  const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = isAdmin
    ? useEntitiesList("tenants", "name asc", undefined, "")
    : [associatedTenants, false];

  const getHeader = () => {
    return (
      <Can
        roles={[roles.ADMIN]}
        yes={() => (
          <div className="action-container">
            <Link
              title="Aggiungi dealer"
              className="btn btn-primary p-button-icon-only"
              to={`/admin/add-tenant`}
            >
              <FontAwesomeIcon icon="user-cog" /> Nuovo Dealer
            </Link>
          </div>
        )}
        no={() => <span>Selezionare il Dealer da rendere attivo</span>}
      />
    );
  };

  const getActiveRow = rowData => {
    return {
      "bg-brand-slack": rowData._id === (activeTenant ? activeTenant._id : "")
    };
  };

  const getColumns = () => {
    return [
      <Column
        key="col-1"
        field="name"
        style={{ wordWrap: "break-word" }}
        header="Nome"
        sortable
        filter
        filterMatchMode="contains"
        body={(rowData, column) => {
          return (
            <Link
              to=""
              onClick={() => onSetActiveTenant(rowData)}
            >
              {rowData.name}
            </Link>
          );
        }}
      />,
      <Column
        key="col-9"
        field="type"
        header="Ruolo"
        sortable
        filter
        filterMatchMode="contains"
        style={{ wordWrap: "break-word" }}
        body={(rowData) => isAdmin ? "admin" : rowData.type}
      />,
      <Column
        key="col-3"
        field={!isAdmin ? "phone" : "attributes.phone"}
        header="Telefono"
        sortable
        filter
        filterMatchMode="contains"
        style={{ wordWrap: "break-word" }}
      />,
      <Column
        key="col-2"
        field="email"
        header="Email"
        sortable
        filter
        style={{ wordWrap: "break-word" }}
      />,
      <Column
        key="col-4"
        field="address.street"
        header="Indirizzo"
        style={{ wordWrap: "break-word" }}
        sortable
        filter
        filterMatchMode="contains"
      />,
      <Column
        key="col-5"
        field="address.region"
        header="Regione"
        style={{ wordWrap: "break-word" }}
        sortable
        body={getRegion}
        filter={!isAdmin ? false : true}
        filterElement={
          !isAdmin ? (
            undefined
          ) : (
              <DropdownFilterElement
                field="address.region"
                options={geo.getRegions()}
                onChange={e => dtable.filter(e.value, e.field, e.type)}
              />
            )
        }
      />,
      <Column
        key="col-6"
        field="address.city"
        header="Comune"
        style={{ wordWrap: "break-word" }}
        sortable
        body={getCity}
      />,

      <Column
        key="col-7"
        field={!isAdmin ? "reference1" : "attributes.reference1"}
        style={{ wordWrap: "break-word" }}
        header="Rif."
        sortable
        filter={!isAdmin ? false : true}
        filterMatchMode="contains"
      />,
      <Column
        key="col-8"
        field="actions"
        body={(rowData, column) => {
          return (
            <div className="action-container">
              <Button
                color="success"
                title="Imposta come dealer attivo"
                onClick={() => onSetActiveTenant(rowData)}
                className="btn-sm p-button-icon-only"
              >
                <FontAwesomeIcon icon="hand-pointer" />
              </Button>
              <Can
                roles={[roles.ADMIN]}
                yes={() => (
                  <React.Fragment>
                    <Link
                      title="Visualizza struttura"
                      className="btn btn-sm btn-info p-button-icon-only"
                      to={`/admin/tenants-hierarchy/${rowData._id}`}
                    >
                      <i className="pi pi-sitemap"></i>
                    </Link>
                    <Link
                      title="Gestisci dealer"
                      className="btn btn-sm btn-primary p-button-icon-only"
                      to={`/admin/tenants/${rowData._id}`}
                    >
                      <i className="pi pi-pencil"></i>
                    </Link>
                    <Button
                      color="danger"
                      title="Elimina dealer"
                      onClick={() => setOpenModal(rowData)}
                      className="btn-sm p-button-icon-only"
                    >
                      <FontAwesomeIcon icon="trash-alt" />
                    </Button>
                  </React.Fragment>
                )}
                no={() => null}
              />
            </div>
          );
        }}
        style={{ wordWrap: "normal" }}
      />
    ];
  };

  const onRefresh = () => {
    forceRefresh();
    setGlobalFilter("");
  }

  const exportTable = () => {
    dtable.exportCSV();
  }

  return (
    <PageLayout title="Elenco Dealer">
      <Row>
        <Col>
          {!isAdmin ? (
            <DataTable
              key="tenantselector"
              value={result}
              ref={dt => (dtable = dt)}
              paginator={true}
              autoLayout={false}
              header="Imposta il Dealer attivo"
              rowsPerPageOptions={[5, 10, 20]}
              rowClassName={getActiveRow}
              rows={5}
              emptyMessage={() => (<div className="text-center">Nessun Dealer in tabella</div>)}
              className="p-datatable-hoverable-rows p-datatable-customers"
              paginator
              paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
              currentPageReportTemplate="Visualizzati {first} di {last} Dealer su un totale di {totalRecords}"
            >
              {getColumns()}
            </DataTable>
          ) : (
              <DataTable
                rowClassName={getActiveRow}
                ref={el => {
                  dtable = el;
                }}
                loading={loading}
                value={result}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                className="p-datatable-hoverable-rows p-datatable-customers"
                emptyMessage={() => (<div className="text-center">Nessun Dealer in tabella</div>)}
                responsive
                paginator={true}
                autoLayout={false}
                first={0}
                rows={20}
                totalRecords={result.length}
                paginatorPosition="both"
                header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                globalFilter={globalFilter}
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                currentPageReportTemplate="Visualizzati {first} di {last} Dealer su un totale di {totalRecords}"
              >
                {getColumns()}
              </DataTable>
            )}
        </Col>
      </Row>
      {modalSection()}
    </PageLayout>
  );
}
